module.exports = __webpack_public_path__ + "img/dotsAll.76445592.svg";